import React from 'react';

import PropTypes from 'prop-types';

import A from 'wanderu-component-react-router-link';
import {
    CarrierLogo,
} from 'wanderu-components';

import more from './more.svg';

import styles from './TopCarriers.scss';

function TopCarriers(props) {
    const {
        carriers,
    } = props;

    function renderCarrier(carrier) {
        const {
            name,
            carrierCode,
            pageSlug,
        } = carrier;

        return (
            <A
                className={styles.carrierCell}
                href={`/carrier/${pageSlug}/`}
                key={name}
            >
                <CarrierLogo
                    carrierCode={carrierCode}
                    carrierName={name}
                    seoLazyload={true}
                    width={81}
                />
            </A>
        );
    }

    return (
        <div className={styles.container}>
            <div className={styles.carrierGrid}>
                {carriers.map(renderCarrier)}
                <A
                    className={styles.andManyMore}
                    href="/carrier/"
                >
                    <img className={styles.more} src={more} />
                    30+ More
                </A>
            </div>
        </div>
    );
}

TopCarriers.propTypes = {
    carriers: PropTypes.arrayOf(
        PropTypes.shape({
            carrierCode: PropTypes.string,
            name: PropTypes.string,
            pageSlug: PropTypes.string,
        }),
    ),
};

export { TopCarriers };
